import { useState, useRef } from 'react';
import useOutsideClick from '../../../hook/useOutsideClick';

const UnitBedRow = ({ item, roomStart, index, number, letter, setManageUnitBedModalData, setDeleteUnitBed }) => {
  const dropdownRef = useRef();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  useOutsideClick(dropdownRef, () => setIsDropdownOpen(false));

  return (
    <div className={`tr ${roomStart && index != 0 ? 'room-start' : ''}`}>
      <div className="td">{number}</div>
      <div className="td">{letter}</div>
      <div className="td">
        <p className="resident-name">
          {item.resident?.last_name} {item.resident?.first_name}
        </p>
      </div>
      <div className="td td-action">
        <div className="dropdown unit-bed-dropdown" ref={dropdownRef}>
          <button
            onClick={(e) => {
              e.stopPropagation();
              setIsDropdownOpen(!isDropdownOpen);
            }}
            className="btn btn-outline unit-bed-dropdown-btn"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path
                d="M9.99984 10.832C10.4601 10.832 10.8332 10.4589 10.8332 9.9987C10.8332 9.53846 10.4601 9.16536 9.99984 9.16536C9.5396 9.16536 9.1665 9.53846 9.1665 9.9987C9.1665 10.4589 9.5396 10.832 9.99984 10.832Z"
                fill="#667085"
              />
              <path
                d="M9.99984 4.9987C10.4601 4.9987 10.8332 4.6256 10.8332 4.16536C10.8332 3.70513 10.4601 3.33203 9.99984 3.33203C9.5396 3.33203 9.1665 3.70513 9.1665 4.16536C9.1665 4.6256 9.5396 4.9987 9.99984 4.9987Z"
                fill="#667085"
              />
              <path
                d="M9.99984 16.6654C10.4601 16.6654 10.8332 16.2923 10.8332 15.832C10.8332 15.3718 10.4601 14.9987 9.99984 14.9987C9.5396 14.9987 9.1665 15.3718 9.1665 15.832C9.1665 16.2923 9.5396 16.6654 9.99984 16.6654Z"
                fill="#667085"
              />
              <path
                d="M9.99984 10.832C10.4601 10.832 10.8332 10.4589 10.8332 9.9987C10.8332 9.53846 10.4601 9.16536 9.99984 9.16536C9.5396 9.16536 9.1665 9.53846 9.1665 9.9987C9.1665 10.4589 9.5396 10.832 9.99984 10.832Z"
                stroke="#667085"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M9.99984 4.9987C10.4601 4.9987 10.8332 4.6256 10.8332 4.16536C10.8332 3.70513 10.4601 3.33203 9.99984 3.33203C9.5396 3.33203 9.1665 3.70513 9.1665 4.16536C9.1665 4.6256 9.5396 4.9987 9.99984 4.9987Z"
                stroke="#667085"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M9.99984 16.6654C10.4601 16.6654 10.8332 16.2923 10.8332 15.832C10.8332 15.3718 10.4601 14.9987 9.99984 14.9987C9.5396 14.9987 9.1665 15.3718 9.1665 15.832C9.1665 16.2923 9.5396 16.6654 9.99984 16.6654Z"
                stroke="#667085"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
          {isDropdownOpen && (
            <ul className="dropdown-menu">
              <li>
                <button
                  className="btn btn-left btn-full btn-text"
                  onClick={(e) => {
                    e.stopPropagation();
                    setManageUnitBedModalData(item);
                    setIsDropdownOpen(false);
                  }}
                >
                  <i className="icon-icon-edit mr-2"></i>Edit
                </button>
              </li>
              <li>
                <button
                  className="btn btn-left btn-full btn-danger btn-text"
                  onClick={(e) => {
                    e.stopPropagation();
                    setDeleteUnitBed(item);
                    setIsDropdownOpen(false);
                  }}
                >
                  <i className="icon-remove mr-2"></i>Delete
                </button>
              </li>
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default UnitBedRow;
